import React from 'react';
import ServicePage from '../components/services/ServicePage';
import parasols from '../data/services/parasols';

const Parasols: React.FC = () => <ServicePage data={parasols} />;

export default Parasols;
